export default "__VITE_ASSET__DVT2XgsN__"